<template>
  <v-row class="customer-detail custom-border-to">
    <v-col md="12" sm="12" class="pt-0">
      <div class="new-white-box-overview-main nav">
        <div class="col-md-12 pt-0 px-0">
          <v-skeleton-loader
            class="custom-skeleton"
            v-if="pageLoading"
            type="text@5"
          >
          </v-skeleton-loader>

          <table class="width-100">
            <template>
              <tr>
                <th
                  colspan="2"
                  class="grey lighten-4 font-size-16 color-custom-blue py-1 text-uppercase"
                >
                  Lead Information
                </th>
              </tr>
              <tr>
                <td
                  class="py-1 font-size-18 text-capitalize font-weight-500"
                  width="120"
                >
                  Lead #
                </td>
                <td class="py-1">
                  <div class="font-weight-600 font-size-18">
                    <v-skeleton-loader
                      class="custom-skeleton"
                      v-if="pageLoading"
                      type="button"
                    >
                    </v-skeleton-loader>
                    <Barcode v-else :barcode="getBarcode"></Barcode>
                  </div>
                </td>
              </tr>
              <tr>
                <td
                  class="py-1 font-size-18 text-capitalize font-weight-500"
                  valign="top"
                >
                  Lead Name
                </td>
                <td class="py-1 font-size-18 text-capitalize">
                  <template v-if="lead.lead_name">{{
                    lead.lead_name
                  }}</template>
                  <template v-else
                    ><em class="text-muted">No lead name</em></template
                  >
                </td>
              </tr>

              <tr>
                <td colspan="2" style="height: 10px"></td>
              </tr>

              <tr class="mt-2">
                <th
                  colspan="2"
                  class="grey lighten-4 font-size-16 color-custom-blue py-1 text-uppercase"
                >
                  Contact Details
                </th>
              </tr>
              <tr>
                <td class="py-1 font-size-18 font-weight-500">Email Address</td>
                <td class="py-1 font-size-18" v-if="lead && lead.email">
                  {{ lead.email }}
                </td>
                <td v-else><em class="text-muted"> no email address</em></td>
              </tr>
              <tr>
                <td class="py-1 font-size-18 text-capitalize font-weight-500">
                  Phone Number
                </td>
                <td
                  class="py-1 font-size-18 text-capitalize"
                  v-if="lead && lead.phone_number"
                >
                  {{ lead.phone_number }}
                </td>
                <td v-else class="pb-2">
                  <em class="text-muted"> no phone number</em>
                </td>
              </tr>

              <tr>
                <td colspan="2" style="height: 10px"></td>
              </tr>

              <tr>
                <th
                  colspan="2"
                  class="grey lighten-4 font-size-16 color-custom-blue py-1 text-uppercase"
                >
                  Address Details
                </th>
              </tr>
              <tr>
                <td
                  class="py-1 font-size-18 text-capitalize font-weight-500"
                  width="120"
                >
                  Address Line 1
                </td>
                <td class="py-1 font-size-18 text-capitalize">
                  <template v-if="lead.address_line_1">{{
                    lead.address_line_1
                  }}</template>
                  <template v-else>
                    <em class="text-muted">no address line 1</em></template
                  >
                </td>
              </tr>
              <tr>
                <td class="py-1 font-size-18 text-capitalize font-weight-500">
                  Address Line 2
                </td>
                <td class="py-1 font-size-18 text-capitalize">
                  <template v-if="lead.address_line_2">{{
                    lead.address_line_2
                  }}</template>
                  <template v-else>
                    <em class="text-muted">no address line 2</em></template
                  >
                </td>
              </tr>

              <tr>
                <td class="py-1 font-size-18 font-weight-500">Unit No.</td>
                <td class="py-1 font-size-18 text-capitalize">
                  <template v-if="lead.unit_no">{{ lead.unit_no }}</template>
                  <template v-else>
                    <em class="text-muted">No Unit No.</em></template
                  >
                </td>
              </tr>

              <tr>
                <td class="py-1 font-size-18 font-weight-500">Postal Code</td>
                <td class="py-1 font-size-18 text-capitalize">
                  <template v-if="lead.postal_code">{{
                    lead.postal_code
                  }}</template>
                  <template v-else>
                    <em class="text-muted">no postal code</em></template
                  >
                </td>
              </tr>

              <tr>
                <td class="py-1 font-size-18 text-capitalize font-weight-500">
                  Country
                </td>
                <td class="py-1 font-size-18 text-capitalize">
                  <template v-if="lead.country">{{ lead.country }}</template>
                  <template v-else>
                    <em class="text-muted">No Country</em></template
                  >
                </td>
              </tr>
            </template>
          </table>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import Barcode from "@/view/pages/partials/Barcode.vue";
import FileManagerMixin from "@/core/lib/file-manager/file.manager.mixin";

export default {
  name: "contact-details",
  title: "Customer",
  mixins: [CommonMixin, FileManagerMixin],
  data() {
    return {
      imageLoading: false,
    };
  },
  props: {
    lead: {
      type: Object,
      required: true,
      default: function () {
        return {};
      },
    },
    pageLoading: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    selectImage() {
      this.$refs["uploadImage"].$refs["input"].click();
    },
    updateProfileImage(param) {
      const _this = this;
      let customerId =
        _this.customer && _this.customer.id ? _this.customer.id : 0;
      _this.imageLoading = true;
      _this
        .uploadAttachment(param, customerId, "customer")
        .then((response) => {
          _this.customer.profile_logo = _this.lodash.head(response);
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.imageLoading = false;
        });
    },
    getDetailType(param) {
      if (param === 1) {
        return "Email";
      }
      return "Phone";
    },
  },
  components: {
    Barcode,
  },
  computed: {
    customerActivated() {
      const _this = this;
      if (_this.lodash.isEmpty(_this.lead) === false) {
        return _this.lead.status;
      }
      return false;
    },
    fullname() {
      let name = "";
      const _this = this;
      if (
        _this.customer &&
        _this.lodash.isEmpty(_this.customer.persons) === false
      ) {
        for (let i = 0; i < _this.customer.persons.length; i++) {
          if (_this.customer.persons[i].default) {
            name =
              _this.lodash.startCase(_this.customer.persons[i].title) +
              ". " +
              _this.customer.persons[i].first_name +
              " " +
              _this.customer.persons[i].last_name;
          }
        }
      }
      return name;
    },
    primaryEmail() {
      let email = "";
      const _this = this;
      if (
        _this.customer &&
        _this.lodash.isEmpty(_this.customer.details) === false
      ) {
        for (let i = 0; i < _this.customer.details.length; i++) {
          if (_this.customer.details[i].type === 1) {
            email = _this.customer.details[i].value;
            break;
          }
        }
      }
      return email;
    },
    primaryPhone() {
      let phone = "";
      const _this = this;
      if (
        _this.customer &&
        _this.lodash.isEmpty(_this.customer.details) === false
      ) {
        for (let i = 0; i < _this.customer.details.length; i++) {
          if (_this.customer.details[i].type === 2) {
            phone = _this.customer.details[i].value;
            break;
          }
        }
      }
      return phone;
    },
    getProfileImage() {
      if (!this.customer.profile_logo) {
        return null;
      }
      return this.customer.profile_logo.file.url;
    },
    getBarcode() {
      if (!this.lead.barcode) {
        return "";
      }
      return this.lead.barcode;
    },
  },
};
</script>
